<template>
    <aside
        v-if="article.body?.toc"
        class="order-first self-start py-4 lg:sticky lg:top-[calc(var(--header-height)+2rem)] lg:order-last lg:col-span-2 lg:ml-auto"
    >
        <p class="!mt-0">{{ t('toc') }}</p>

        <ul class="not-prose overflow-hidden">
            <li
                v-for="link in article.body.toc.links"
                :key="link.id"
                class="not-prose text-base hover:text-blue-500"
            >
                <NuxtLink
                    :to="`#${link.id}`"
                    :class="
                        activeId === link.id
                            ? 'text-blue-500'
                            : '!text-gray-500'
                    "
                    class="inline-block"
                >
                    {{ link.text }}
                </NuxtLink>
            </li>
        </ul>
    </aside>
</template>

<script setup lang="ts">
import type { BlogArticle } from '~/types/blog'

defineProps({
    article: {
        type: Object as PropType<BlogArticle>,
        required: true,
    },
    activeId: {
        type: String,
        required: true,
    },
})

const { t } = useI18n()
</script>

<i18n lang="yaml">
en:
    toc: Съдържание
bg:
    toc: Съдържание
</i18n>
